module.exports = __webpack_public_path__ + "static/media/trust.c3d4c478.png";